export default {
  name: "pro-input-add",
  props: {
    list: {
      type: Array,
      default() {
        return [];
      }
    },
    detail: {
      type: Boolean,
      default() {
        return false;
      }
    },
    icon: {
      type: String,
      default() {
        return "";
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    onClick() {
      this.$emit("onClick");
    },
    iconRender(item) {
      if (item.userId) {
        return "md-person";
      } else if (item.orgId) {
        return "md-folder";
      } else if (item.tagId) {
        return "md-pricetag";
      } else if (item.appId) {
        return "md-apps";
      }
    }
  }
};